export const NIGHT_CANVAS = {
  width: 2560,
  height: 1600
} as const;

export const NIGHT_ASSETS = {
  wallpaper: "assets/figma/night-ai/wallpaper.webp",
  topDock: "assets/figma/night-ai/top-dock.svg",
  timeReference: "assets/figma/night-ai/time-reference-api.png",
  timeReferenceSvg: "assets/figma/night-ai/time-reference.svg",
  floatingShortcut: "assets/figma/night-ai/floating-shortcut.svg",
  evaStand: "assets/figma/night-ai/eva-stand.png",
  evaFront: "assets/figma/night-ai/eva-front.png",
  evaLookDown: "assets/figma/night-ai/eva-look-down.svg",
  evaPortrait: "assets/figma/night-ai/eva-portrait.webp",
  avatar: "assets/figma/night-ai/avatar.webp",
  qqMusic: "assets/figma/night-ai/qq-music.png",
  musicCover: "assets/figma/night-ai/music-cover.webp",
  aiCard: "assets/figma/night-ai/left-ai-card-shell.svg",
  parkingCard: "assets/figma/night-ai/middle-parking-card.svg",
  musicCard: "assets/figma/night-ai/right-music-card.svg",
  bottomDock: "assets/figma/night-ai/bottom-dock-api.png",
  bottomDockSvg: "assets/figma/night-ai/bottom-dock.svg",
  traditionalDesktop: "assets/figma/traditional-desktop.webp",
  traditionalDock: "assets/figma/traditional-dock.png",
  traditionalCarwashNavigation: "assets/figma/traditional-carwash-navigation.webp",
  traditionalParcelNavigation: "assets/figma/traditional-parcel-navigation.webp",
  traditionalChargingNavigation: "assets/figma/traditional-charging-navigation.webp"
} as const;

export const NIGHT_LAYOUT = {
  statusBar: {
    x: 0,
    y: 0,
    width: 2560,
    height: 104
  },
  floatingShortcut: {
    x: 2392,
    y: 168,
    width: 104,
    height: 104
  },
  heroTime: {
    x: 882,
    y: 68,
    width: 796,
    height: 597,
    figmaText: {
      x: 868,
      y: 68,
      width: 825,
      height: 597,
      fontFamily: "SF Pro",
      fontPostScriptName: "SFPro-Medium",
      fontSize: 500,
      referenceText: "09:30"
    }
  },
  dock: {
    x: 0,
    y: 1440,
    width: 2560,
    height: 160
  },
  aiCard: {
    x: 208,
    y: 1200,
    width: 688,
    height: 200
  },
  infoCards: {
    parking: {
      x: 936,
      y: 1200,
      width: 688,
      height: 200
    },
    music: {
      x: 1664,
      y: 1200,
      width: 688,
      height: 200
    }
  },
  bottomCards: {
    group: {
      x: 208,
      y: 1200,
      width: 2144,
      height: 200
    },
    cards: [
      {
        x: 208,
        y: 1200,
        width: 688,
        height: 200
      },
      {
        x: 936,
        y: 1200,
        width: 688,
        height: 200
      },
      {
        x: 1664,
        y: 1200,
        width: 688,
        height: 200
      }
    ]
  },
  evaStand: {
    x: 1074,
    y: 427,
    width: 61,
    height: 247
  },
  evaPortrait: {
    x: 1130,
    y: 400,
    width: 300,
    height: 300
  }
} as const;
